export default __webpack_public_path__ + "static/media/Grocery.9d7279e1.svg";